import { FixSessionsTable } from '@/routes/_authed/$client_code/markets/$market_code/connections/-components/fixSessionsTable.tsx'
import { ItchConnectionsTable } from '@/routes/_authed/$client_code/markets/$market_code/connections/-components/itchConnectionsTable.tsx'
import NewItchConnectionMenuItem from '@/routes/_authed/$client_code/markets/$market_code/connections/-components/newItchConnectionMenuItem.tsx'
import { Navigate, createFileRoute } from '@tanstack/react-router'

import { useGetClientMarket } from '@/gen/publicApi'

import { UnexpectedDataStateError } from '@/containers/unexpectedDataStateError'

import Content from '@/components/content'
import OptionMenu from '@/components/optionMenu'

import { useSetBreadcrumbs } from '@/state/breadcrumbs'

import MarketHeading from '../-components/marketHeading'
import MarketNavigation from '../-components/marketNavigation'

import NewFixSessionMenuItem from './-components/newFixSessionMenuItem.tsx'

export const Route = createFileRoute('/_authed/$client_code/markets/$market_code/connections/')({
    component: MarketConnectionsComponent,
})

function MarketConnectionsComponent() {
    const { market_code, client_code } = Route.useParams()
    const { data: market } = useGetClientMarket(client_code, market_code, { query: { suspense: true } })

    useSetBreadcrumbs([
        {
            to: '/$client_code/markets',
            text: 'Markets',
            params: {
                client_code,
            },
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code',
            params: {
                market_code,
                client_code,
            },
            text: market?.name || '--',
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code/connections',
            params: {
                market_code,
                client_code,
            },
            text: 'Connections',
        },
    ])

    if (!market) {
        return <UnexpectedDataStateError />
    }

    if (market.marketType === 'Template') {
        // Templates don't have connections so navigate away from this page
        return <Navigate to={`/$client_code/markets/$market_code`} params={{ client_code, market_code }} />
    }

    return (
        <>
            <MarketHeading market={market} />
            <Content>
                <MarketNavigation active="connections">
                    <OptionMenu>
                        <NewFixSessionMenuItem clientCode={client_code} marketCode={market_code} />
                        <NewItchConnectionMenuItem clientCode={client_code} marketCode={market_code} />
                    </OptionMenu>
                </MarketNavigation>

                <h3 className="text-2xl mt-4 mb-2">FIX</h3>
                <FixSessionsTable client_code={client_code} market_code={market_code} />

                <h3 className="text-2xl mt-4 mb-2">ITCH</h3>
                <ItchConnectionsTable client_code={client_code} market_code={market_code} />
            </Content>
        </>
    )
}
